// extracted by mini-css-extract-plugin
export default {"item":"CalendarViewToggle_item__XOI9D"};